// extracted by mini-css-extract-plugin
export default {"container":"style_container__m7dis","text":"style_text__8Fod+","copyButton":"style_copyButton__bu273"};